import { Controller } from "@hotwired/stimulus"
import { useTransition, useHotkeys } from 'stimulus-use'
import { useEmitter } from "@/emitter"

export default class extends Controller {
    static targets = [
        'video'
    ]

    connect() {
        useEmitter(this)

        useHotkeys(this, {
            'escape': [this.escHandler]
        })

        useTransition(this, {
            enterActive: "transition ease-out duration-300",
            enterFrom: "transform-gpu opacity-0 scale-95",
            enterTo: "transform-gpu opacity-100 scale-100",
            leaveActive: "transition ease-in duration-300",
            leaveFrom: "transform-gpu opacity-100 scale-100",
            leaveTo: "transform-gpu opacity-0 scale-95",
            hiddenClass: 'hidden',
            transitioned: false,
        })

        this.$on('join:open', () => {
            this.$emit('ym:reachGoal', 'join:open')
            this.enter()
            this.$emit('scroll:disable')
        })

        this.$on('join:close', () => {
            this.$emit('scroll:enable')
            this.leave()
        })

        if (this.hasVideoTarget) {
            this.videoTarget.load()

            this.$on('join:open', async () => {
                try {
                    await this.videoTarget.play()
    
                    if (this.hidden) {
                        await this.videoTarget.pause()
                    }
                } catch (error) {
                    
                }
            })
    
            this.$on('join:close', async () => {
                if (this.videoIsPlaying) {
                    await this.videoTarget.pause()
                }
            })
        }

        this.hashchangeHandle = () => {
            if(location.hash === '#join') {
                this.$emit('join:open')
            }
        }

        addEventListener('hashchange', this.hashchangeHandle)
        
        this.hashchangeHandle();
    }
    
    disconnect() {
        removeEventListener('hashchange', this.hashchangeHandle)
        this.$clear()
    }

    escHandler() {
        if (!this.hidden) {
            this.$emit('join:close')
        }
    }

    get videoIsPlaying() {
        const video = this.videoTarget

        return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2)
    }

    get hidden () {
        return this.element.classList.contains('hidden')
    }

    set hidden (value) {
        return this.element.classList.toggle('hidden', value)
    }
}
